import { render, staticRenderFns } from "./CallbackAzure.vue?vue&type=template&id=6626d8e1&scoped=true"
import script from "./CallbackAzure.vue?vue&type=script&lang=js"
export * from "./CallbackAzure.vue?vue&type=script&lang=js"
import style0 from "./CallbackAzure.vue?vue&type=style&index=0&id=6626d8e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626d8e1",
  null
  
)

export default component.exports